import { consumerFilterPayload } from "utils/consumerFilterUtils";
import api from "api/api";
import SortFinalData from "utils/SortFinalData";
import { generateBoxAnalysisPayload } from "utils/boxAnalysisUtils";

const GetSecondaryResult = async ({ product = null, coreDataId = null, type = null, consumerFilter = null, pcs = [], selectedStudy = [], productsSecondaryDataState = null, order = [], productCategoryId = null, boxAnalysisSelection = {}, isHairCare = false }) => {
    let analysisResult = [];
    const boxAnalysisFilter = await generateBoxAnalysisPayload(boxAnalysisSelection);
    try {
        if (type === "consumerFilter" && consumerFilter) {
            let filter = await consumerFilterPayload(consumerFilter, product, coreDataId);
            const matchedProduct = productsSecondaryDataState?.find(ele => ele.title.split(" ").filter(item => item != "").join("_") === product);
            const _pc = matchedProduct?.title;
            await api
                .post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, {
                    variable_category: isHairCare ? "Secondary Attribute,Concept Secondary Attribute" : "Secondary Attribute",
                    core_data_id: coreDataId,
                    product_code: _pc,
                    consumer_filter: { ...filter },
                    product_category: productCategoryId,
                    box_analysis: boxAnalysisFilter,
                })
                .then(async (res) => {
                    const object = res.data[0];
                    const finalData = await productsSecondaryDataState.map((datum) => (datum.title === _pc && datum.coreDataId.toString() === coreDataId.toString() ? object : datum));
                    analysisResult = finalData;
                })
                .catch((error) => {
                    console.error("Error", error);
                });
        } else if (type === "consumerFilterAll" && consumerFilter) {
            if (pcs.length !== 0) {
                const requests = pcs.map(async (datum) => {
                    let filter = await consumerFilterPayload(consumerFilter, datum.product, datum.coreDataId);
                    const matchedProduct = productsSecondaryDataState?.find(ele => ele.title.split(" ").filter(item => item != "").join("_") === datum.product);
                    const _pc = matchedProduct?.title;
                    return api.post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, {
                        variable_category: isHairCare ? "Secondary Attribute,Concept Secondary Attribute" : "Secondary Attribute",
                        core_data_id: datum.coreDataId,
                        product_code: _pc,
                        consumer_filter: { ...filter },
                        product_category: productCategoryId,
                        box_analysis: boxAnalysisFilter,
                    });
                });
                await api
                    .all(requests)
                    .then(async (res) => {
                        const results = res.map((re) => re.data).flat();
                        var finalData = productsSecondaryDataState.map((datum) => {
                            const obj = { ...datum };
                            const match = results.find((item) => item.title === datum.title);
                            obj["scores"] = [];
                            obj["sampleSize"] = 0;
                            return match ? { ...obj, ...match } : obj;
                        });
                        analysisResult = finalData;
                    })
                    .catch((error) => {
                        console.error("Error", error);
                    });
            }
        } else {
            if (selectedStudy.length !== 0) {
                const requests = selectedStudy.map((datum) =>
                    api.post(process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/grouped/`, {
                        core_data_id: datum.id,
                        variable_category: isHairCare ? "Secondary Attribute,Concept Secondary Attribute" : "Secondary Attribute",
                        product_category: productCategoryId,
                        box_analysis: boxAnalysisFilter,
                    })
                );

                await api
                    .all(requests)
                    .then((res) => {
                        const results = res.map((re) => re.data).flat();
                        analysisResult = results;
                    })
                    .catch((error) => {
                        console.error("Error", error);
                    });
            }
        }
    } catch (error) {
        console.error("Error", error);
    }
    analysisResult = SortFinalData(analysisResult, order);
    return analysisResult;
};

export default GetSecondaryResult;
